// @flow
import {fromJS, Map} from "immutable";
import {electricalMetersSelector} from "../../meter/"
import {metersSelector} from "../../meter";
import {BILLABLE, CREDIT, PARTIAL} from "../../../constants";

export const allAccountsSelector = (state: Map<string, any>) => state.getIn(["account", "accounts"]);
export const accountErrorSelector = (state: Map<string, any>) => state.getIn(["account", "error"]);
export const accountInfoSelector = (state: Map<string, any>) => state.getIn(["account", "accountInfo"]);
export const accountGridSelector = (state: Map<string, any>) => state.getIn(["account", "grid"]);

export const accountCreditMetersSelector = (state: Map<string, any>) => state.getIn(["account", CREDIT, "meters"]);
export const accountBillableMetersSelector = (state: Map<string, any>) => state.getIn(["account", BILLABLE, "meters"]);
export const accountPartialMetersSelector = (state: Map<string, any>) => state.getIn(["account", PARTIAL, "meters"]);

export const accountBillableLocationFiltersSelector = (state: Map<string, any>) => state.getIn(["account", BILLABLE, "filters", "location"]);
export const accountBillableGroupFiltersSelector = (state: Map<string, any>) => state.getIn(["account", BILLABLE, "filters", "group"]);
export const accountBillableAddressFiltersSelector = (state: Map<string, any>) => state.getIn(["account", BILLABLE, "filters", "meter"]);

export const accountCreditLocationFiltersSelector = (state: Map<string, any>) => state.getIn(["account", CREDIT, "filters", "location"]);
export const accountCreditGroupFiltersSelector = (state: Map<string, any>) => state.getIn(["account", CREDIT, "filters", "group"]);
export const accountCreditAddressFiltersSelector = (state: Map<string, any>) => state.getIn(["account", CREDIT, "filters", "meter"]);

export const accountPartialPercentageSelector = (state: Map<string, any>) => state.getIn(["account", PARTIAL, "percentage"]);
export const accountPartialLocationFiltersSelector = (state: Map<string, any>) => state.getIn(["account", PARTIAL, "filters", "location"]);
export const accountPartialGroupFiltersSelector = (state: Map<string, any>) => state.getIn(["account", PARTIAL, "filters", "group"]);
export const accountPartialAddressFiltersSelector = (state: Map<string, any>) => state.getIn(["account", PARTIAL, "filters", "meter"]);

/**
 *
 * @param locationFilters - applied location filters
 * @param meters - list of all available meters
 * @param groupFilters - applied group filters (to prevent duplicate filters being added)
 * @returns [string]
 */
export const filterMeterGroups = (locationFilters ,meters, groupFilters) => {
  let groups = []
  if (locationFilters && locationFilters.size) {
    locationFilters.forEach(locationFilter => {
      meters.forEach(meter => {
        if (locationFilter === meter.get("locationId") && !groups.includes(meter.get("group"))) {
          groups.push(meter.get("group"))
        }
      })
    })
  } else {
    meters.forEach(meter => {
      if (!groups.includes(meter.get("group"))) {
        groups.push(meter.get("group"))
      }
    })
  }

  if (groupFilters && groupFilters.size) {
    groups = groups.filter(g => !groupFilters.some(gf => gf === g))
  }
  return fromJS(groups);
}

export const locationAccountBillableFilteredGroupsSelector = (state: Map<string, any>) => {
  const locationFilters = accountBillableLocationFiltersSelector(state)
  const meters = state.getIn(["meter", "meters"])
  const groupFilters = accountBillableGroupFiltersSelector(state)
  return filterMeterGroups(locationFilters, meters, groupFilters)
}
export const locationAccountCreditFilteredGroupsSelector = (state: Map<string, any>) => {
  const locationFilters = accountCreditLocationFiltersSelector(state)
  const electricalMeters = electricalMetersSelector(state)
  const groupFilters = accountCreditGroupFiltersSelector(state)
  return filterMeterGroups(locationFilters, electricalMeters, groupFilters)
}
export const locationAccountPartialFilteredGroupsSelector = (state: Map<string, any>) => {
  const locationFilters = accountPartialLocationFiltersSelector(state)
  const meters = metersSelector(state)
  const groupFilters = accountPartialGroupFiltersSelector(state)
  return filterMeterGroups(locationFilters, meters, groupFilters)
}

export const filterMeterAddresses = (locationFilters, groupFilters, meters, addressFilters) => {
  let filteredMeters = meters.map(m => m)

  if (locationFilters && locationFilters.size) {
    locationFilters.forEach(locationFilter => {
      filteredMeters = filteredMeters.filter(fm => fm.get("locationId") === locationFilter)
    })
  }


  if (groupFilters && groupFilters.size) {
    groupFilters.forEach(groupFilter => {
      filteredMeters = filteredMeters.filter(fm => groupFilter === fm.get("group"))
    })
  }

  if (addressFilters && addressFilters.size) {
    addressFilters.forEach(addressFilter => {
      filteredMeters = filteredMeters.filter(fm => addressFilter !== fm.get("addressId"))
    })
  }

  filteredMeters = filteredMeters
    .reduce((uniqueItems, meter) => {
      const addressId = meter.get('addressId')
      !uniqueItems.includes(addressId) && uniqueItems.push(addressId)
      return uniqueItems
    }, [])

  return fromJS(filteredMeters)
}

export const locationAccountBillableFilteredAddressesSelector = (state: Map<string, any>) => {
  const locationFilters = accountBillableLocationFiltersSelector(state),
        groupFilters = accountBillableGroupFiltersSelector(state),
        meters = metersSelector(state),
        addressFilters = accountBillableAddressFiltersSelector(state)
  return filterMeterAddresses(locationFilters, groupFilters, meters, addressFilters)
}
export const locationAccountCreditFilteredAddressesSelector = (state: Map<string, any>) => {
  const locationFilters = accountCreditLocationFiltersSelector(state),
        groupFilters = accountCreditGroupFiltersSelector(state),
        electricalMeters = electricalMetersSelector(state),
        addressFilters = accountCreditAddressFiltersSelector(state)
  return filterMeterAddresses(locationFilters, groupFilters, electricalMeters, addressFilters)
}
export const locationAccountPartialFilteredAddressesSelector = (state: Map<string, any>) => {
  const locationFilters = accountPartialLocationFiltersSelector(state),
        groupFilters = accountPartialGroupFiltersSelector(state),
        meters = metersSelector(state),
        addressFilters = accountPartialAddressFiltersSelector(state)
  return filterMeterAddresses(locationFilters, groupFilters, meters, addressFilters)
}

export const accountBillableMeterSerialNumbersSelector = (state: Map<string, any>) => state.getIn(["account", BILLABLE, "meters"]).map(meter => meter.get("meterSerialNumber"));
export const accountCreditMeterSerialNumbersSelector = (state: Map<string, any>) => state.getIn(["account", CREDIT, "meters"]).map(meter => meter.get("meterSerialNumber"));
export const accountPartialMeterSerialNumbersSelector = (state: Map<string, any>) => state.getIn(["account", PARTIAL, "meters"]).map(meter => meter.get("meterSerialNumber"));


export const accountIsFetchingSelector = (state: Map<string, any>) => state.getIn(["account", "isFetchingData"])




// WEBPACK FOOTER //
// ./src/features/account/store/accountSelectors.js